import { useEffect, useState } from "react";
import axios from "../../api/adminAxios";
import AdminSidebar from "./AdminSidebar";

interface RequestLimitData {
    plan: string;
    limit: number;
}

export default function AdminChatLimit() {
    const [limit, setLimit] = useState<number>(100);
    const [showModal, setShowModal] = useState(false);
    const [newLimit, setNewLimit] = useState<string>("");

    useEffect(() => {
        axios.get<RequestLimitData>("/admin/chat-limit/basic").then(res => {
            setLimit(res.data.limit);
            setNewLimit(res.data.limit.toString());
        });
    }, []);

    const handleSave = async () => {
        if (!isNaN(parseInt(newLimit))) {
            await axios.post("/admin/chat-limit/basic", { limit: parseInt(newLimit) });
            setLimit(parseInt(newLimit));
            setShowModal(false);
        }
    };

    return (
        <div className="min-h-screen flex bg-gray-100">
            <AdminSidebar />

            <div className="flex-1 p-6">
                <div className="bg-white rounded-lg shadow-md p-6 max-w-2xl mx-auto">
                    <h2 className="text-2xl font-bold mb-4">🧮 Basic Plan Chat Request Limit</h2>
                    <div className="border rounded p-4 bg-gray-50 shadow-sm">
                        <p className="text-gray-700 text-lg">
                            Current Limit: <span className="font-semibold text-blue-600">{limit}</span> requests/month
                        </p>
                        <button
                            onClick={() => setShowModal(true)}
                            className="mt-4 bg-blue-600 text-white px-5 py-2 rounded hover:bg-blue-700 transition"
                        >
                            ✏️ Edit Limit
                        </button>
                    </div>
                </div>

                {/* Modal */}
                {showModal && (
                    <div className="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-50">
                        <div className="bg-white p-6 rounded shadow-md w-full max-w-sm">
                            <h3 className="text-xl font-semibold mb-4">Update Basic Plan Limit</h3>
                            <input
                                type="number"
                                value={newLimit}
                                onChange={(e) => setNewLimit(e.target.value)}
                                className="w-full border px-3 py-2 rounded mb-4 focus:outline-none focus:ring-2 focus:ring-blue-500"
                            />
                            <div className="flex justify-end space-x-3">
                                <button
                                    onClick={() => setShowModal(false)}
                                    className="px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"
                                >
                                    Cancel
                                </button>
                                <button
                                    onClick={handleSave}
                                    className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                                >
                                    Save
                                </button>
                            </div>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
}
